import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useQuoteCart } from "@/context/QuoteCartContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { addItem } = useQuoteCart();
  const [size, setSize] = useState(product.sizes?.[0]?.label || "");

  const handleAdd = () => {
    if (!size) return;
    addItem({
      product_id: product.id,
      product_name: product.name,
      size_label: size,
      quantity: 1,
      image_url: product.image_url,
    });
    toast.success(`${product.name} (${size}) added to quote cart`);
  };

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group relative bg-white rounded-2xl overflow-hidden border border-brand-line shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-1"
    >
      <Link to={`/product/${product.slug}`} className="block overflow-hidden aspect-square bg-brand-pinkSoft">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-700 ease-out"
          loading="lazy"
        />
      </Link>

      <div className="px-5 pt-4 pb-5 flex flex-col gap-3">
        <div>
          <div className="eyebrow">{product.category}</div>
          <Link to={`/product/${product.slug}`} className="block mt-1">
            <h3 className="font-display text-2xl text-brand-ink leading-tight hover:text-brand-red transition-colors">
              {product.name}
            </h3>
          </Link>
        </div>

        <p className="text-sm text-brand-stone leading-relaxed line-clamp-2 font-ui">
          {product.short_description}
        </p>

        <div className="flex flex-wrap gap-1.5 pt-1">
          {product.sizes?.map((s) => (
            <button
              key={s.label}
              onClick={() => setSize(s.label)}
              data-testid={`product-${product.slug}-size-${s.label}`}
              className={`px-3 py-1 rounded-full text-xs font-ui font-semibold transition ${
                size === s.label
                  ? "bg-brand-red text-white"
                  : "bg-brand-pinkLight text-brand-ink hover:bg-brand-pink"
              }`}
            >
              {s.label} {s.label === '3"' ? "Mini" : "Whole"}
            </button>
          ))}
        </div>

        <button
          onClick={handleAdd}
          data-testid={`add-quote-${product.slug}`}
          className="mt-2 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-brand-red text-white text-sm font-ui font-semibold hover:bg-brand-redDark active:scale-[0.98] transition"
        >
          <Plus className="w-4 h-4" /> Add to Quote
        </button>
      </div>
    </div>
  );
}
